const profile = {
  profile: {
    title: 'إعدادات الملف الشخصي',
    subtitle: 'إدارة معلومات حسابك',
    editProfile: 'تعديل الملف الشخصي',
    cancel: 'إلغاء',
    saving: 'جارٍ الحفظ...',
    saveChanges: 'حفظ التغييرات',
    signOut: 'تسجيل الخروج',

    // التبويبات
    profileTab: 'الملف الشخصي',
    favoritesTab: 'المفضلة',

    // تسميات النموذج
    firstName: 'الاسم الأول',
    lastName: 'اسم العائلة',
    email: 'البريد الإلكتروني',

    // معلومات الحساب
    accountInfo: 'معلومات الحساب',
    userId: 'معرّف المستخدم',
    accountCreated: 'تاريخ إنشاء الحساب',
    emailVerified: 'البريد الإلكتروني مُتحقق منه',
    lastSignIn: 'آخر تسجيل دخول',
    yes: 'نعم',
    pending: 'معلق',
    never: 'أبداً',

    // قسم المساعدة
    needHelp: 'تحتاج مساعدة؟',
    helpText: 'تواصل مع فريق الدعم إذا كنت بحاجة إلى مساعدة في حسابك.',
    contactSupport: 'تواصل مع الدعم',

    // رسائل التحقق من الصحة
    firstNameRequired: 'الاسم الأول مطلوب',
    firstNameTooShort: 'يجب أن يكون الاسم الأول حرفين على الأقل',
    firstNameTooLong: 'يجب أن يكون الاسم الأول أقل من 50 حرفاً',
    lastNameRequired: 'اسم العائلة مطلوب',
    lastNameTooShort: 'يجب أن يكون اسم العائلة حرفين على الأقل',
    lastNameTooLong: 'يجب أن يكون اسم العائلة أقل من 50 حرفاً',
    emailRequired: 'البريد الإلكتروني مطلوب',
    emailInvalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',

    // رسائل النجاح/الخطأ
    updateSuccess: 'تم تحديث الملف الشخصي بنجاح!',
    updateError: 'فشل تحديث الملف الشخصي. يرجى المحاولة مرة أخرى.',
    emailChangeNote: 'تغيير بريدك الإلكتروني سيتطلب التحقق منه',

    // المفضلة
    noFavorites: 'لا توجد مفضلات بعد',
    noFavoritesDescription: 'ابدأ بتصفح العقارات واحفظ المفضلة لديك لتراها هنا.',
    browseProperties: 'تصفح العقارات',
    unknownProperty: 'عقار غير معروف',
  },
};

export default profile;
